import { useEffect } from 'react';
import styled from 'styled-components/macro';
import { Modal } from '@uhg-uicl/ui-core/dist';
import { useAuth } from 'react-oidc-context';

const Container = styled.div`
  padding: 2rem;
`;

export const Logout = () => {
  const auth = useAuth();

  useEffect(() => {
    // put other state cleanup stuff here
    setTimeout(() => {
      auth.signoutRedirect();
    }, 1000);
  }, []);

  return (
    //@ts-ignore
    <Modal domID="no-auth" isOpen showDefaultClose={false}>
      <Container>You are being logged out</Container>
    </Modal>
  );
};

export default Logout;
